import { logisticsAsset, logisticsSafety, manufacturingAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@assets/images/solution/logisticsSafety/video/rtlsVideo.mp4';

export default {
  desc: 'IPS là viết tắt của Indoor Positioning System, là công nghệ theo dõi vị trí chính xác của người dùng hoặc vật thể bên trong các tòa nhà.',
  keywords: 'IPS,LoRa, Công nghệ truyền thông, Cong nghe truyen thong, IoT',
  ogSite: 'IPS(Indoor Positioning System) là gì?',
  title: 'IPS(Indoor Positioning System) là gì?',
  ogUrl: 'https://orbro.io/vi/blog/indoor-positioning-system',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDk6TQ-h2KkQiYudK2spJrwM9-DVyXGqjpnyMQI2sZIQz1hxm14GXjbIy0_vPqBdcWNqBfevlZpTaHCDaKLTSInodrYeccUP3gpQNgAtrMwqEHlrjdh4WhikpPJ_iDLCi3PldIyG97g8uPiEGv2KbKurpE7JoCN5mRkfiH448dzhhpubMZxkB2ZKIJC7k8kNPYcSX1A-QOydJBw_yipl-pCZS_3oxhv2uYggjB0clzoEqTdYWRLydtMHV79DjszkbWJW3LTgrYEKIQP1Kbdw7ZItA-BwStqSuGehlMzlqxoFgQRChchtMnWac9VkUzOWnga-7_XUfmX90CtTqWRrFZg9Umjy8FX9288OQT_dXLNDDdowk_5t23b2mX-L7yW25zgxFHd3VtxgRongH9p94aLi4mMDO6fmT_8ajfcngVp9gOjPzHsmkOESsojVUQc706JPrK__OnMo7qr_aEVb15EIjZlqlJaJ4IhcIuXokNh-sp1nkFHuZ8qW_HXAB3FZu7r91T6rPAmKirnvFAtZdTghCXsX9nzmLybftlK1YYBWTAV0qcWkL5Ckpp2njt9pFjoXmTQqbdpz3duHY-AljIdMbCDzS444jPCLaKfXTkCmbV6WnZRaPfGR81_Q82hX3jxtuLKQmjMmCgLgCl3gp5L8CZi1hvvtQKMdcDSJ90ZUhsu2CZkmvwQ3Q_03VoJSlwwFZ3EUN3W_GB8e5cWXpNGvQccrSjeCnmIF9aVrHwtaIdWTvpskUJKjNzlqAafVUfTouYOSrV8OCfLPwSQTV8iSm2qnbRuoBigg9xouxN0bRwPkIiz67dGt4JKQcqivJnCoQxzvVomW1fVr4UbxMq6akImY3IxQ7ovGV81wA46n8tx5WPSPLMCEKQBK9FkzHiHqb8Pxxw9rzzuIa6TtoY6KRfti9zMv4fsmGqX6Q1_R5B-ABtExcOjVt-x_mS5Y3ZQR0jJIdKh4GEj98Pa9oTTF3saa28UWqTTjqRErmeVY04QTsy_SqFx9CyzU_2V1_zbdvez8hyZLuj5L9K-cvJyCKZTyBCrw0YzWwOX2MZ6fCyqvFzPfzzKJZRUncB0UrOVKw7dGDdDlaX5CqXBk-kR06RFpJIEf1fS0zEk2cBhS3NX2BU_PuueEkq1bQyLe9sG9kxqLXZ9jOc8ImIMr4X6JZgbKdO0-x0t_LkclmAjG3g4QuaNl63oDUgU1QUvQoQhDiCEHrK0xqXRaU7qSPbYXesuwkNkmOgVwPoJnNa-jYCoJ__RR4WZomXaiPckDuGTkSKx2dOfaSs7TbvIb7fqqcv5kVXnVeEtCheiIU220AnBQ6P4vLOzcQM3JP63j9eLnrIAgh2NMqXpyNVhSY5elNnry6i9vqriqjEwypIBg-eRxHD_S7iWd7gaTLIA_cu_QyeVrW7fYEMoc830qGVhoMH7VNFbffpm5PtC_9B2e2P4xe4fQIisHlT1tnhnFJynZshU2YAiNTWNWMEnpEsitAZMUPJ6oRGSQe_DK9xz-bmpANM-9WSuCR8vlKsLHuWX8A516ShbC0Y9wnZQrN3RK1Rt3xRlX=w2045-h1221',
  ogType: 'website',
  date: '2024-01-23',
  tag1: '#RTLS',
  tag2: '#Congnghetruyenthong',
  tag3: '#IoT',
  tag4: '#IPS',
  text: [
    {
      head: 'IPS (Indoor Positioning System) là gì?',
      subHead: '',
      desc: 'IPS là viết tắt của Indoor Positioning System, là công nghệ theo dõi vị trí chính xác của người dùng hoặc vật thể bên trong các tòa nhà. IPS được ứng dụng trong nhiều lĩnh vực khác nhau và cần thiết trong các lĩnh vực như điều hướng trong nhà, tự động hóa, bảo mật, giám sát môi trường và quản lý tài nguyên.\nMặc dù các hệ thống theo dõi vị trí ngoài trời như GPS được sử dụng rộng rãi, việc theo dõi vị trí chính xác trong nhà là một vấn đề phức tạp hơn. IPS là một trong những công nghệ được phát triển để giải quyết vấn đề này. Trong bài viết này, chúng ta sẽ cùng tìm hiểu chi tiết về IPS.',
      dot: '',
    },
    {
      head: 'Tầm quan trọng của IPS',
      subHead: '',
      desc: "Trong xã hội hiện đại, với sự phổ biến của smartphone và các thiết bị di động khác, tầm quan trọng của công nghệ định vị đã tăng lên đáng kể. Công nghệ này đóng vai trò cốt lõi trong việc giúp chúng ta tìm đường thông qua ứng dụng bản đồ hoặc cung cấp thông tin hiệu quả khi mua sắm trong nhà. Một trong những công nghệ định vị như vậy là 'Hệ thống Định vị Trong nhà' hay IPS.\nIPS là thuật ngữ chỉ các công nghệ và hệ thống để xác định và theo dõi chính xác vị trí của thiết bị hoặc người dùng. Nó chủ yếu được sử dụng trong môi trường trong nhà, và khác với GPS (Global Positioning System), nó hoạt động hiệu quả ngay cả bên trong các tòa nhà.",
      dot: '',
    },
    {
      head: 'Nguyên lý hoạt động của IPS',
      subHead: 'Sử dụng Công nghệ UWB',
      desc: 'Công nghệ UWB đo khoảng cách đến các thiết bị hoặc thẻ xung quanh một cách rất chính xác. Dựa vào đó, nó tính toán khoảng cách giữa người dùng và thẻ UWB (ví dụ: smartphone hoặc thẻ ngân hàng).',
      dot: '',
    },
    {
      head: '',
      subHead: 'BLE (Bluetooth Low Energy)',
      desc: 'Đây là phương pháp xác định vị trí trong nhà bằng cách sử dụng các Beacon Bluetooth LE. Beacon phát ra các mã định danh duy nhất, và vị trí được ước tính dựa trên đó. Mặc dù có độ chính xác cao nhưng tốn kém do cần phải bố trí Beacon.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Sử dụng Camera AI',
      desc: 'Camera AI phân tích hình ảnh thu được từ camera để hiểu môi trường xung quanh và có thể phát hiện vật thể hoặc con người. Thông qua đó, camera xác định vị trí và chuyển động của người dùng theo thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Định vị dựa trên Wi-Fi',
      desc: 'Xác định vị trí của người dùng dựa trên cường độ tín hiệu của các điểm truy cập Wi-Fi. Mỗi điểm truy cập Wi-Fi có một địa chỉ MAC duy nhất và được sử dụng để xác định vị trí người dùng. Tuy nhiên, độ chính xác yếu và có thể bị nhiễu tín hiệu hoặc giới hạn phạm vi.',
      dot: '',
    },
    {
      head: 'Ưu điểm của Công nghệ IPS',
      subHead: '',
      desc: 'Vì GPS không hoạt động trong môi trường trong nhà, IPS nâng cao độ chính xác của việc định vị trong nhà. Dựa trên dữ liệu vị trí chính xác, có thể xác định vị trí chính xác của người dùng hoặc tài sản. Ngoài ra, IPS có thể theo dõi vị trí của người dùng hoặc tài sản theo thời gian thực, cho phép giám sát và quản lý theo thời gian thực trong môi trường trong nhà. Điều này rất quan trọng khi thực hiện các biện pháp khẩn cấp trong tình huống khẩn cấp hoặc quản lý tài sản hiệu quả.\nThông qua IPS, các công việc và quy trình có thể được tự động hóa và tối ưu hóa. Ví dụ, trong các nhà máy ô tô, việc sử dụng IPS để định vị robot tự hành có thể nâng cao năng suất. Trong ngành logistics, nó có thể tối ưu hóa quản lý logistics và tài sản để cắt giảm chi phí. Hoặc tại các địa điểm đa dạng như bệnh viện, trường học, sân bay, IPS cũng có thể giúp cải thiện khả năng ứng phó tình huống khẩn cấp, được sử dụng để theo dõi bệnh nhân, đảm bảo an toàn cho học sinh và nhân viên, hướng dẫn đường đi trong các sự kiện lớn.',
      dot: '',
    },
    {
      head: 'Các trường hợp Ứng dụng IPS',
      subHead: 'Dẫn đường nội bộ và Tiếp thị trong Cửa hàng',
      desc: '• Giúp khách hàng dễ dàng tìm thấy sản phẩm mong muốn trong cửa hàng.\n• Đơn giản hóa quy trình đặt hàng và thanh toán, nâng cao trải nghiệm khách hàng.\n• Cải thiện tiếp thị bằng cách xác định vị trí khách hàng để cung cấp gợi ý sản phẩm và thông tin giảm giá.\n',
      dot: '',
    },
    {
      head: '',
      subHead: 'Theo dõi Bệnh nhân trong Bệnh viện và Cơ sở Y tế',
      desc: '• Theo dõi bệnh nhân trong các cơ sở y tế và xác định vị trí của họ theo thời gian thực.\n• Đội ngũ y tế có thể nhanh chóng tìm thấy bệnh nhân và chuẩn bị cho các tình huống khẩn cấp.\n• Được sử dụng như một hệ thống hiệu quả để phòng ngừa lây nhiễm và quản lý thiết bị y tế.\n',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hướng dẫn hành khách và An ninh trong Sân bay',
      desc: '• Hành khách có thể dễ dàng tìm thấy cổng lên máy bay, điểm nhận hành lý và các tiện ích dịch vụ trong sân bay.\n• Hỗ trợ quản lý an ninh và quản lý hàng đợi.\n• Hướng dẫn hành khách đến cổng vào đúng giờ để đảm bảo lịch trình bay.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý Trận đấu và Sự kiện trong Cơ sở Thể thao và Giải trí trong nhà',
      desc: '• Khán giả có thể tìm thấy chỗ ngồi và đặt đồ ăn, thức uống trong sân vận động.\n• Cung cấp kết quả trận đấu và thông tin đội theo thời gian thực để nâng cao trải nghiệm giải trí.\n• Thực hiện quản lý trận đấu và sự kiện một cách hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý Logistics và Tài sản trong Nhà máy và Kho hàng',
      desc: '• Theo dõi và xác định vị trí thiết bị, sản phẩm và tài sản trong nhà máy hoặc kho hàng.\n• Tối ưu hóa quản lý logistics và chuỗi cung ứng, nâng cao năng suất.\n• Hỗ trợ quản lý tồn kho và tối ưu hóa tuyến đường di chuyển.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hướng dẫn Sinh viên và Giảng viên trong Khuôn viên Trường học và Đại học',
      desc: '• Sinh viên và giảng viên có thể dễ dàng tìm thấy phòng học, thư viện, nhà ăn và bãi đỗ xe trong khuôn viên trường.\n• Hỗ trợ theo dõi điểm danh sinh viên và quản lý tài nguyên giáo dục.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự hành trong nhà và Hợp tác Robot',
      desc: '• Công nghệ định vị trong nhà giúp phương tiện tự hành và robot đi theo lộ trình chính xác.\n• Nâng cao hiệu quả làm việc của robot, cho phép chúng thực hiện nhiều nhiệm vụ khác nhau.',
      dot: '',
    },
    {
      head: 'Triển vọng phát triển tương lai của IPS',
      subHead: '',
      desc: 'Công nghệ IPS tiếp tục phát triển và được kỳ vọng sẽ nâng cao độ chính xác và hiệu quả của việc định vị trong nhà. Việc tích hợp với mạng 5G, sự ra đời của Trí tuệ nhân tạo (AI) và Machine Learning, cùng với sự tiến bộ của công nghệ cảm biến, đang cho thấy một tương lai tươi sáng cho IPS. Việc định vị chính xác và nhanh chóng hơn dự kiến sẽ mang lại sự đổi mới và hiệu quả trong nhiều ngành nghề khác nhau.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
